// extracted by mini-css-extract-plugin
export default {"container":"BlackListDialog_container__pZHQF"};